import { render } from "./CompleteImgCalltype.vue?vue&type=template&id=19ef1f74&scoped=true&ts=true"
import script from "./CompleteImgCalltype.vue?vue&type=script&lang=ts"
export * from "./CompleteImgCalltype.vue?vue&type=script&lang=ts"

import "./CompleteImgCalltype.vue?vue&type=style&index=0&id=19ef1f74&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ef1f74"]])

export default __exports__